import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { IAutomationItem } from '../../types';

interface IDeleteTaskDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  task: IAutomationItem | null;
  isDeleting: boolean;
}

const DeleteTaskDialog = ({
  open,
  onClose,
  onConfirm,
  task,
  isDeleting,
}: IDeleteTaskDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '12px',
          minWidth: '400px',
          fontFamily: 'Tajawal, sans-serif',
        },
      }}
    >
      <DialogTitle
        sx={{
          fontFamily: 'Tajawal, sans-serif',
          fontWeight: 700,
          fontSize: '18px',
          color: '#37352F',
        }}
      >
        {t('Automation.deleteTask')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          sx={{
            fontFamily: 'Tajawal, sans-serif',
            fontSize: '14px',
            color: '#435363',
          }}
        >
          {t('Automation.deleteTaskConfirmation', {
            taskName: task?.name ?? '',
          })}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: '16px 24px', gap: '8px' }}>
        <Button
          onClick={onClose}
          disabled={isDeleting}
          sx={{
            fontFamily: 'Tajawal, sans-serif',
            textTransform: 'none',
            color: '#435363',
            borderRadius: '8px',
          }}
        >
          {t('Automation.cancel')}
        </Button>
        <Button
          onClick={onConfirm}
          disabled={isDeleting}
          variant="contained"
          sx={{
            backgroundColor: '#E74C3C',
            fontFamily: 'Tajawal, sans-serif',
            textTransform: 'none',
            fontWeight: 700,
            borderRadius: '8px',
            minWidth: '80px',
            '&:hover': { backgroundColor: '#C0392B' },
          }}
        >
          {isDeleting ? (
            <CircularProgress size={20} sx={{ color: '#fff' }} />
          ) : (
            t('Automation.delete')
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteTaskDialog;
